import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['details', 'detailsToggle']

  closeDetails() {
    requestAnimationFrame(() => {
      this.detailsTarget.classList.add('closed')
      this.detailsToggleTarget.classList.remove('hidden')
    })
  }

  showDetails() {
    requestAnimationFrame(() => {
      this.detailsTarget.classList.remove('closed')
      this.detailsToggleTarget.classList.add('hidden')
    })
  }
}
